import { WSSelectOption } from "@wingspanhq/fe-component-library";
import { LedgerAccount } from "@wingspanhq/wingspan-api-sdk";
import sortBy from "lodash/sortBy";

/**
 * QuickBooks ledger accounts as `WSSelect` options, sorted by label. The v3
 * counterpart of `selectQuickbooksAccountOrItemOptions` for the account side;
 * the option value is the reference id the payee mapping write stores
 * (`quickbooksExpenseAccountId`).
 *
 * v1 labelled these with `fullyQualifiedName` (the "Parent:Child" path); v3
 * carries only `displayName`, so a sub-account (`isSubAccount`) shows its own
 * name rather than its full path — same drift `selectorAccountingItemOptions`
 * notes for items.
 */
export const selectorLedgerAccountOptions = (
  accounts?: LedgerAccount[]
): WSSelectOption[] =>
  sortBy(
    (accounts || []).map(account => ({
      label: account.displayName,
      value: account.id,
      searchText: account.displayName
    })),
    option => option.label.toLocaleLowerCase()
  );
